"use strict";exports.__esModule = true;exports.tsToSec = tsToSec;exports.tsToMs = tsToMs;

var _misc = require("../misc");

/**
                                 * Переводит timestamp в секунды
                                 *
                                 *
                                 * @param {number} ts
                                 * @example
                                 * tsToSec( 1528304655612 ) // 1528304656
                                 * tsToSec( 1528304656 ) // 1528304656
                                 * tsToSec( 'asd' ) // 0
                                 * @returns {number}
                                 * @memberof Time
                                 */
function tsToSec(ts) {
  var checkResult = (0, _misc.checkTimestamp)(ts);
  if (!checkResult.isValid) {
    console.warn('ts is not valid', ts);
    return 0;
  }if (checkResult.isInSec) {
    return ts;
  }
  return Math.round(ts / 1000);
}

/**
   * Переводит timestamp в милисекунды
   *
   *
   * @param {number} ts
   * @example
   * tsToMs( 1528304656 ) // 1528304655612
   * tsToMs( 1528304655612 ) // 1528304655612
   * tsToMs( 'asd' ) // 0
   * @returns {number}
   * @memberof Time
   */
function tsToMs(ts) {
  var checkResult = (0, _misc.checkTimestamp)(ts);
  if (!checkResult.isValid) {
    console.warn('ts is not valid', ts);
    return 0;
  }

  return checkResult.isInSec ? ts * 1000 : ts;
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/convert/tsTo.js
// module id = 310
// module chunks = 0